import React, { FC, useEffect, useRef } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { useIMask } from 'react-imask';
import { additionalFieldsNumberMaskOptions } from '../numberMask';

export type NumberMaskFieldProps = Omit<
  TextFieldProps,
  'value' | 'onChange' | 'inputRef'
> & {
  value: number | null | undefined;
  onChange: (value: number | null) => void;

};

export const NumberMaskField: FC<NumberMaskFieldProps> = ({
  value,
  onChange,
  label,
  variant = 'standard',
  inputProps,
  ...rest
}) => {
  const refLastValue = useRef<number|string|null | undefined>(null);
  const {
    ref,
    value: maskValue,
    setTypedValue,
    setValue,
    typedValue,
  } = useIMask(
    {
      ...additionalFieldsNumberMaskOptions,
    },
    {
      onAccept: (_value, mask) => {
        
        if(!_value) {
          onChange(null);
          refLastValue.current = _value;
          return;
        }
        const typed = mask.typedValue as number | null | undefined;

        if(refLastValue.current === typed) {
          return;
        }
        
        refLastValue.current = typed;
      
        if (typed === undefined || typed === null) {
          onChange(null);
          return;
        }
        onChange(Number.isFinite(typed) ? typed : null);
      },
    },
  );

  useEffect(() => {
    if (value === null || value === undefined) {
      refLastValue.current = null;
      setValue('');
      return;
    }

    if (!Number.isFinite(Number(value))) {
      return;
    }

    // Если внутренняя маска уже находится в этом числовом значении,
    // не дергаем setValue ещё раз, чтобы не сбрасывать позицию курсора.
    if (refLastValue.current === value) {
      return;
    }

    refLastValue.current = value;
    setValue(String(value).replaceAll('.', ','));
  }, [value, setValue]);

 

  return (
    <TextField
      {...rest}
      label={label}
      variant={variant}
      inputRef={ref}
      value={maskValue ?? ''}
      
      inputProps={{
        ...inputProps,
        inputMode: 'decimal',
      }}
    />
  );
};
